import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import moment from "moment";
import CatalogoOrdenesdePagosPlanillas from "../../catalogos/catalogoOrdenesdePagosPlanillas";
import { validaSoloNumero, formatMoneda, validaEmail } from "../../util/varios";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import {
  EnhancedTableHead,
  stableSort,
  getComparator,
} from "../../util/varios";
import Table from "@mui/material/Table";
import Checkbox from "@mui/material/Checkbox";

import {
  DangerButton,
  InfoButton,
  PrimaryButton,
} from "../../ui/buttons/Button";
import { SearchInput, Input, Select, Radio } from "../../ui/inputs/Input";
import { Button } from "react-bootstrap";

export const ImpRetenciones = (props) => {
  let op = require("../../modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;

  const [activate, setActivate] = useState(false);
  const [habiBot, setHabiBot] = useState(false);
  const [habiBuscar, setHabiBuscar] = useState(false);
  const [habiCorreo, setHabiCorreo] = useState(false);
  const [habiNumPlani, setHabiNumPlani] = useState(false);
  const [habiFechaRet, setHabiFechaRet] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [existePlani, setExistePlani] = useState(false);
  const [llamadoPlani, setLlamadoPlani] = useState(false);
  const [reversado, setReversado] = useState(0);
  const [idOrden, setIdOrden] = useState(0);
  const [desde, setDesde] = useState(0);
  const [cambioDatos, setCambioDatos] = useState(false);
  const [permiEliminar, setPermiEliminar] = useState(0);
  const [visibleP, setVisibleP] = useState("hidden");
  const [ultimo, setUltimo] = useState(false);
  const [page] = useState(0);
  const [rowsPerPage] = useState(10);
  const [records, setRecords] = useState([]);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, records.length - page * rowsPerPage);
  const [dense] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [usuario, setUsuario] = useState("");
  const [nomOrg, setNomOrg] = useState("");

  const [newRecord, setNewRecord] = useState();

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    if (obj != null) {
      setUsuario(obj.login);
      setNomOrg(obj.nombreorg);
    } else {
      setUsuario("");
      setNomOrg("");
    }
  }, []);

  const handleClick = (event, data) => {
    const { idret } = data;
    let newSelected = [];
    const selectedIndex = selected.indexOf(data);
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, data);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
    if (selectedItems.some((item) => item.idret === idret)) {
      setSelectedItems(selectedItems.filter((item) => item.idret !== idret));
    } else {
      setSelectedItems([...selectedItems, data]);
    }
  };

  const isSelected = (idret) => {
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].idret === idret) {
        return true;
      }
    }
    return null;
  };

  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const btnImprimir = useRef();
  const btnEnviar = useRef();
  const txtCodigo = useRef();
  const txtMontoOrden = useRef();
  const cmbTipoRetencion = useRef();
  const txtTipoCompromiso = useRef();
  const txtFechaOrden = useRef();
  const txtFechaRetencion = useRef();
  const txtNumeroPlanilla = useRef();
  const txtIdprov = useRef();
  const txtCedurifprov = useRef();
  const txtNombreprov = useRef();
  const txtCorreoP = useRef();
  const txtCorreoS = useRef();
  const radioSi = useRef();
  const txtNo = useRef();
  const txtApellido = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtCel = useRef();
  const txtFechaNac = useRef();
  const [selected, setSelected] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const headCells = [
    {
      id: "0",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "",
      textAlign: "center",
      width: "40px",
    },
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Tipo de Retención",
      textAlign: "center",
      width: "200px",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "PLanilla Enviada",
      textAlign: "center",
      width: "80px",
    },
  ];
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleSelectAllClick = (event, cual) => {
    event.preventDefault();
    if (event.target.checked) {
      const newSelecteds = records.map((item) => item);
      setSelected(newSelecteds);
      setSelectedItems(newSelecteds);
      return;
    } else {
      setSelected([]);
      setSelectedItems([]);
    }
  };
  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputNombres") {
        txtApellido.current.focus();
      } else if (event.target.id === "inputApellidos") {
        txtDireccion.current.focus();
      } else if (event.target.id === "inputDireccion") {
        txtEmail.current.focus();
      } else if (event.target.id === "inputEmail1") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtCorreoS.current.focus();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Formato de email invalido.",
            icono: "informacion",
          });
          event.target.value = "";
        }
      } else if (event.target.id === "inputEmail2") {
        valido = validaEmail(event.target.value);
        if (valido) {
          btnImprimir.current.focus();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Formato de email invalido.",
            icono: "informacion",
          });
          event.target.value = "";
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputTlf") {
        txtCel.current.focus();
      } else if (event.target.id === "inputCel") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const cancelar = () => {
    txtCodigo.current.value = "";
    blanquear();
    //props.setShow(false);
  };

  const blanquear = () => {
    setHabiBot(false);
    setHabiBuscar(true);
    setHabiCorreo(false);
    setHabiFechaRet(false);
    setHabiNumPlani(false);
    setLlamadoPlani(false);
    txtMontoOrden.current.value = "";
    txtTipoCompromiso.current.value = "";
    txtFechaOrden.current.value = "";
    txtFechaRetencion.current.value = "";
    txtNumeroPlanilla.current.value = "";
    txtIdprov.current.value = "";
    txtCedurifprov.current.value = "";
    txtNombreprov.current.value = "";
    txtCorreoP.current.value = "";
    txtCorreoS.current.value = "";
    setRecords([]);
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
    } else if (desde === 2) {
      imprimirPlanila(idOrden);
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "El Egreso Nª" + idOrden + " fué Registrado Correctamente",
        icono: "exito",
      });
    } else if (desde === 3) {
      imprimirPlanila(idOrden);
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: "Egreso Registrado Correctamente",
        icono: "exito",
      });
    } else if (desde === 4) {
      procesarCambioAutorizacion();
    } else {
    }
  };

  const cerrarModal = () => {
    props.setTabla(0);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.setShow(false);
    txtCodigo.current.value = "";
    blanquear();
  };

  const cerrarMensaje = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 8) {
      if (props.operacion === 1) {
        setDesde(2);
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "Desea Imprimir En este Momento Comprobante de Egreso?",
          icono: "confirmacion",
        });
      } else if (props.operacion === 2) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Reversado",
          icono: "exito",
        });
      } else if (props.operacion === 3) {
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El Egreso N° " + txtCodigo.current.value + " fué Eliminado",
          icono: "exito",
        });
      }
    }
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.which === 13) {
        if (event.target.id === "idorden") {
          txtCorreoP.current.focus();
        } else if (event.target.id === "idprov") {
          txtIdprov.current.focus();
        } else if (event.target.id === "idcuenta") {
          txtNumeroPlanilla.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const seleccionarOrdenPago = (codigo, tipo) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarordenpagodual?idorden=${codigo}&idefi=${idefiscal}&tipo=${tipo}&norden=${norden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idordenpago > 0) {
            txtIdprov.current.value = response.data.idproveedor;
            txtMontoOrden.current.value = formatMoneda(
              response.data.montoordenpago
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2,
            );
            txtFechaOrden.current.value = moment
              .utc(response.data.fecha)
              .format("YYYY-MM-DD");
            txtCedurifprov.current.value = response.data.rif;
            txtNombreprov.current.value = response.data.razonsocial;
            txtCorreoP.current.value =
              response.data.correoepri !== null
                ? response.data.correoepri.trim()
                : "";
            txtCorreoS.current.value =
              response.data.correoesec !== null
                ? response.data.correoesec.trim()
                : "";
            setHabiCorreo(true);
            setHabiBuscar(false);
            setReversado(response.data.reversado);
            switch (response.data.tipo) {
              case 5:
                txtTipoCompromiso.current.value = "ORDEN DE COMPRA";
                break;
              case 7:
                txtTipoCompromiso.current.value = "PAGO DE OBRAS";
                break;
              case 11:
                txtTipoCompromiso.current.value = "ORDEN DE SERVICIO";
                break;
              case 12:
                txtTipoCompromiso.current.value = "PAGO DIRECTO";
                break;
              case 13:
                txtTipoCompromiso.current.value = "PAGO DE NOMINA";
                break;
              case 0:
                txtTipoCompromiso.current.value = "ORDEN DE PAGO FINANCIERA";
                break;
            }
            setIdOrden(response.data.idordenpago);
            setHabiBot(true);
            seleccionarRetenciones(response.data.idordenpago);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡Código i/o La Orden de Pago, No Existe!",
              icono: "error",
            });
            txtIdprov.current.value = "";
            txtCedurifprov.current.value = "";
            txtNombreprov.current.value = "";
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRetenciones = (idop) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarretencionesop?idorden=${idop}&idefi=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let dat = [];
          for (let x = 0; x < response.data.length; x++) {
            if (
              response.data[x].ret_tipo !== null &&
              response.data[x].tipo !== 2
            ) {
              dat = [...dat, response.data[x]];
            }
          }
          if (dat.length > 0) {
            let reg = dat;
            setRecords(reg);
            if (
              parseInt(reg[0].tipo === 4) ||
              parseInt(reg[0].tipo) === 6 ||
              parseInt(reg[0].tipo) === 0 ||
              parseInt(reg[0].tipo) === 1
            ) {
              setVisibleP("visible");
              radioSi.current.checked = true;
              txtNo.current.checked = false;
            } else {
              setVisibleP("hidden");
            }
            const newSelecteds = reg.map((item) => item);
            setSelected(newSelecteds);
            setSelectedItems(newSelecteds);
            txtFechaRetencion.current.value = moment
              .utc(reg[0].fecharet)
              .format("YYYY-MM-DD");
            setHabiFechaRet(true);
            seleccionarNumeroPlanilla(idop);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Error.",
              texto: "¡No Existen Retenciones!",
              icono: "error",
            });
          }
        }
      })
      .catch((error) => {
        setMensaje({ mostrar: true, titulo: "Error", icono: "error" });
        setActivate(false);
      });
  };

  const seleccionarNumeroPlanilla = (idop) => {
    let endpoint = `${op.conexion}/api/administracion/seleccionarnumeroplanilla?idordenp=${idop}&idefi=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: { "x-access-token": `${token}` },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtNumeroPlanilla.current.value = response.data.numplanilla;
          setUltimo(response.data.ultimo);
          setExistePlani(response.data.existe);
          setLlamadoPlani(response.data.llamaplani);
          if (parseInt(response.data.llamaplani) !== 2) {
            setHabiNumPlani(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({ mostrar: true, titulo: "Error", icono: "error" });
        setActivate(false);
      });
  };

  const catalogoOrdenPago = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const handleCancelaOrdenPago = () => {
    setMostrar4(false);
  };

  const handleAceptarOrdenPago = (
    numordenpago,
    razonsocial,
    idproveedor,
    fecha,
    idordenpago,
    tipo,
  ) => {
    setMostrar4(false);
    if (props.operacion === 1) {
      setHabiBot(false);
    } else {
      setHabiBot(true);
    }
    setIdOrden(idordenpago);
    txtCodigo.current.value = norden ? numordenpago : idordenpago;
    seleccionarOrdenPago(norden ? numordenpago : idordenpago, tipo);
  };

  const procesarCambioAutorizacion = () => {
    let valor = permiEliminar === 0 ? 1 : 0;
    let body = {
      idegreso: txtCodigo.current.value,
      valor: permiEliminar === 0 ? 1 : 0,
      idefiscal: idefiscal,
    };
    let endpoint = `${op.conexion}/api/administracion/autorizardesautorizareliminaregreso`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setCambioDatos(true);
          setPermiEliminar(valor);
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "Se " +
              (valor === 1 ? "Autorizó" : "Desautorizó") +
              " la elimización del Egreso",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const imprimirPlanila = () => {
    if (txtFechaRetencion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Retención",
        icono: "informacion",
      });
      txtFechaRetencion.current.focus();
      return;
    }
    let a_tipo = [];
    a_tipo.push({
      tipo: records[cmbTipoRetencion.current.selectedIndex].tipo,
    });
    let tipo = records[cmbTipoRetencion.current.selectedIndex].tipo;
    let body = {
      tipo: a_tipo,
      fecha: txtFechaRetencion.current.value,
      existe: existePlani,
      idorden: idOrden,
      idefi: idefiscal,
      ultimo: txtNumeroPlanilla.current.value,
      llamaplani: llamadoPlani,
      valor: 2,
    };

    let endpoint = `${op.conexion}/api/administracion/actualizarplanillaretencion`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var reporte = "";
          var sql = idOrden;
          var sql2 = "0";
          if (tipo === 0) {
            tipo = 1;
            if (radioSi.current.checked) {
              if (norden) {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "ForRetencionIVAF";
                } else {
                  reporte = "ForRetencionIVANumOrden";
                }
              } else {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "ForRetencionIVAF";
                } else {
                  reporte = "ForRetencionIVA";
                }
              }
            } else {
              if (norden) {
                reporte = "ForRetencionIVANumOrden";
              } else {
                reporte = "ForRetencionIVAMed";
              }
            }
          } else if (tipo == 1) {
            tipo = 2;

            if (radioSi.current.checked) {
              if (norden) {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "ForRetencionISLRNumOrdenF";
                } else {
                  reporte = "ForRetencionISLRNumOrden";
                }
              } else {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "ForRetencionISLRNumOrdenF";
                } else {
                  reporte = "ForRetencionISLR";
                }
              }
            } else {
              if (norden) {
                reporte = "ForRetencionISLRNumOrden";
              } else {
                reporte = "ForRetencionISLRMed";
              }
            }
          } else if (tipo == 3) {
            tipo = 3;
            if (espiritu === 0 || espiritu === 3 || espiritu === 4) {
              reporte = "PlanillaIAE";
            } else {
              if (norden) {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "PlanillaRetenAENumOrdenE";
                } else {
                  reporte = "PlanillaRetenAENumOrden";
                }
              } else {
                reporte = "PlanillaRetenAE";
              }
            }
          } else if (tipo == 4) {
            tipo = 4;
            if (radioSi.current.checked) {
              if (espiritu === 8) {
                reporte = "PlanillaReten1x1000_1Anz";
              } else {
                if (norden) {
                  reporte = "PlanillaReten1x1000_1NumOrden";
                } else {
                  reporte = "PlanillaReten1x1000_1";
                }
              }
            } else {
              if (espiritu === 8) {
                reporte = "PlanillaReten1x1000Anz";
              } else {
                if (norden) {
                  reporte = "PlanillaReten1x1000NumOrden";
                } else {
                  reporte = "PlanillaReten1x1000";
                }
              }
            }
          } else if (tipo == 5) {
            tipo = 5;
            reporte = "PlanillaRetenRS";
          } else if (tipo == 6) {
            tipo = 6;
            if (norden) {
              if (radioSi.current.checked) {
                if (
                  txtTipoCompromiso.current.value === "ORDEN DE PAGO FINANCIERA"
                ) {
                  reporte = "PlanillaReten1x1000_1NumOrdenF";
                } else {
                  reporte = "PlanillaReten1x1000_1NumOrden";
                }
              } else {
                reporte = "PlanillaReten1x1000NumOrden";
              }
            } else {
              if (radioSi.current.checked) {
                reporte = "PlanillaReten1x1000_1";
              } else {
                reporte = "PlanillaReten1x1000";
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No Existe Ningún Reporte Asociado a la Retención",
              icono: "informacion",
            });
            return;
          }
          sql2 = tipo.toString();
          var sql1 = "0";
          // var concepto = '';
          var fecha = moment
            .utc(txtFechaRetencion.current.value)
            .format("DD/MM/YYYY");
          window.open(
            op.reportes +
              "/administracionTesoreria?" +
              "reporte=" +
              reporte +
              "&ID=" +
              sql +
              "&CONSELLO=" +
              sql1 +
              "&TIPO=" +
              sql2.trim() +
              "&NOMELA=" +
              usuario +
              "&VALIDO=" +
              reversado.toString() +
              "&FECHA=" +
              fecha +
              "&EFISCAL=" +
              idefiscal,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
          );
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const enviarCorreo = () => {
    if (txtFechaRetencion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Retención",
        icono: "informacion",
      });
      txtFechaRetencion.current.focus();
      return;
    } else if (
      txtCorreoP.current.value.trim() === "" &&
      txtCorreoS.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El proveedor no posee correo electronico",
        icono: "informacion",
      });
      txtCorreoP.current.focus();
      return;
    }
    let datosrete = [];
    let a_tipo = [];
    for (let i = 0; i < selectedItems.length; i++) {
      a_tipo.push({
        tipo: selectedItems[i].tipo,
      });
    }
    let body = {
      tipo: a_tipo,
      fecha: txtFechaRetencion.current.value,
      existe: existePlani,
      idorden: idOrden,
      idefi: idefiscal,
      ultimo: txtNumeroPlanilla.current.value,
      llamaplani: llamadoPlani,
      valor: 2,
    };
    let endpoint = `${op.conexion}/api/administracion/actualizarplanillaretencion`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          for (let i = 0; i < a_tipo.length; i++) {
            let tipo = a_tipo[i].tipo;
            var reporte = "";
            var sql = idOrden;
            var sql2 = "0";
            var nomreporte = "";
            if (tipo === 0) {
              tipo = 1;
              if (radioSi.current.checked) {
                if (norden) {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "ForRetencionIVAF";
                  } else {
                    reporte = "ForRetencionIVANumOrden";
                  }
                } else {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "ForRetencionIVAF";
                  } else {
                    reporte = "ForRetencionIVA";
                  }
                }
              } else {
                if (norden) {
                  reporte = "ForRetencionIVANumOrden";
                } else {
                  reporte = "ForRetencionIVAMed";
                }
              }
              nomreporte = "PlanillaRetencionIva";
            } else if (tipo == 1) {
              tipo = 2;
              if (radioSi.current.checked) {
                if (norden) {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "ForRetencionISLRNumOrdenF";
                  } else {
                    reporte = "ForRetencionISLRNumOrden";
                  }
                } else {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "ForRetencionISLRNumOrdenF";
                  } else {
                    reporte = "ForRetencionISLR";
                  }
                }
              } else {
                if (norden) {
                  reporte = "ForRetencionISLRNumOrden";
                } else {
                  reporte = "ForRetencionISLRMed";
                }
              }
              nomreporte = "PlanillaRetencionISLR";
            } else if (tipo == 3) {
              tipo = 3;
              if (espiritu === 0 || espiritu === 3 || espiritu === 4) {
                reporte = "PlanillaIAE";
              } else {
                if (norden) {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "PlanillaRetenAENumOrdenE";
                  } else {
                    reporte = "PlanillaRetenAENumOrden";
                  }
                } else {
                  reporte = "PlanillaRetenAE";
                }
              }
              nomreporte = "PlanillaRetencionIAE";
            } else if (tipo == 4) {
              tipo = 4;
              if (radioSi.current.checked) {
                if (espiritu === 8) {
                  reporte = "PlanillaReten1x1000_1Anz";
                } else {
                  if (norden) {
                    reporte = "PlanillaReten1x1000_1NumOrden";
                  } else {
                    reporte = "PlanillaReten1x1000_1";
                  }
                }
              } else {
                if (espiritu === 8) {
                  reporte = "PlanillaReten1x1000Anz";
                } else {
                  if (norden) {
                    reporte = "PlanillaReten1x1000NumOrden";
                  } else {
                    reporte = "PlanillaReten1x1000";
                  }
                }
              }
              nomreporte = "PlanillaRetencion1x1000";
            } else if (tipo == 5) {
              tipo = 5;
              reporte = "PlanillaRetenRS";
              nomreporte = "PlanillaRetencionRS";
            } else if (tipo == 6) {
              tipo = 6;
              if (norden) {
                if (radioSi.current.checked) {
                  if (
                    txtTipoCompromiso.current.value ===
                    "ORDEN DE PAGO FINANCIERA"
                  ) {
                    reporte = "PlanillaReten1x1000_1NumOrdenF";
                  } else {
                    reporte = "PlanillaReten1x1000_1NumOrden";
                  }
                } else {
                  reporte = "PlanillaReten1x1000NumOrden";
                }
              } else {
                if (radioSi.current.checked) {
                  reporte = "PlanillaReten1x1000_1";
                } else {
                  reporte = "PlanillaReten1x1000";
                }
              }
              nomreporte = "PlanillaRetencion1x1000";
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "No Existe Ningún Reporte Asociado a la Retención",
                icono: "informacion",
              });
              return;
            }
            sql2 = tipo.toString();
            var sql1 = "1";
            // var concepto = '';
            //var Beneficiario = txtRazonProve.current.value;
            var fecha = moment
              .utc(txtFechaRetencion.current.value)
              .format("DD/MM/YYYY");
            datosrete.push({
              nomreporte: nomreporte,
              reporte: reporte,
              ID: sql,
              CONSELLO: sql1,
              TIPO: sql2.trim(),
              NOMELA: usuario,
              VALIDO: reversado.toString(),
              FECHA: fecha,
              EFISCAL: idefiscal,
            });
          }

          setActivate(true);
          let html = "",
            dep = "";
          switch (espiritu) {
            case 0:
              dep = "DEPARTAMENTO DE ADMINISTRACION Y FINANZAS";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                '<td><img src="http://www.alcaldiapaez.gob.ve:81/pagos/Archivos/imagenes/barnePaezMail.png" ></td>' +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n y Finanzas de la Alcald&iacute;a del Municipio P&aacute;ez le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO PAEZ. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO retencionespaez@gmail.com" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO 0255 - 621-39-50. DEPARTAMENTO DE CONTABILIDAD FISCAL, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcald&iacute;a Bolivariana del Municipio P&aacute;ez</td>' +
                " </tr>    <tr>" +
                '<td align="right">Nro. 1 en transparencia Municipal</td>' +
                " </tr>" +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;
            case 1:
              dep = "DEPARTAMENTO DE ADMINISTRACION Y FINANZAS";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                //+ "<td><img src=\"http://www.alcaldiapaez.gob.ve:81/pagos/Archivos/imagenes/barnePaezMail.png\" ></td>"
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n y Finanzas de la Alcald&iacute;a del Municipio Esteller le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO ESTELLER. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO alcaldiadeesteller@gmail.com" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO 0256 - 336-1055. DEPARTAMENTO DE ADMINISTRACION, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcald&iacute;a Bolivariana del Municipio Esteller</td>' +
                " </tr>    <tr>" +
                '<td align="right">Municipio Socialista</td>' +
                " </tr>" +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;
            case 2:
              dep = "DEPARTAMENTO DE ADMINISTRACION";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                //+ "<td><img src=\"http://www.alcaldiapaez.gob.ve:81/pagos/Archivos/imagenes/barnePaezMail.png\" ></td>"
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n  de la alcaldia del municipio Turen le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO TUREN. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO info.alcaldiaturen@gmail.com" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO 0256 - 321-2444. DEPARTAMENTO DE ADMINISTRACION, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcaldia del Municipio Turen</td>' +
                " </tr>    <tr>" +
                '<td align="right">...es de Todos</td>' +
                " </tr>" +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;

            case 12:
              dep = "DIRECCIÓN DE ADMINISTRACION";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                '<td><img src="https://snrafael.opensiap.com.ve/:4200/imagen?img=encabezado.jpg" ></td>' +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n  de la Alcaldia del Municipio San Rafael de Onoto le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO SAN RAFAEL DE ONOTO. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO info.alcaldiaguanare@gmail.com" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcaldia Bolivariana del Municipio San Rafael de Onoto</td>' +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;
            case 15:
              dep = "DIRECCIÓN DE ADMINISTRACION";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                '<td><img src="http://149.56.115.189:2300/imagen?img=sancarlos_original.png" ></td>' +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n  de la Alcaldia del Municipio Guanare le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO GUANARE. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO info.alcaldiaguanare@gmail.com" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO 0257 - 321-2444. DEPARTAMENTO DE ADMINISTRACION, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcaldia Bolivariana del Municipio Guanare</td>' +
                " </tr>    <tr>" +
                '<td align="right">!Tierra de Fe¡</td>' +
                " </tr>" +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;

            default:
              dep = "DEPARTAMENTO DE ADMINISTRACION Y FINANZAS";
              html =
                '<html><body><table width="760" border="0" cellspacing="0" cellpadding="0"> ' +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                " <tr>" +
                //+ "<td><img src=\"http://www.alcaldiapaez.gob.ve:81/pagos/Archivos/imagenes/barnePaezMail.png\" ></td>"
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td>Sr(a):<strong>   </strong></td>" +
                "</tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                "<tr>" +
                "<td>Estimado Proveedor:<strong>" +
                txtNombreprov.current.value.trim() +
                "</strong></td>" +
                " </tr>" +
                "<tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                "<td>La Direcci&oacute;n de Administraci&oacute;n y Finanzas de la " +
                nomOrg.trim() +
                " le notifica que le estamos enviando adjunto a este correo  " +
                (
                  "Planilla(s) de Retencion de Orden de Pago N° " +
                  txtCodigo.current.value.trim()
                )
                  .trim()
                  .toLowerCase() +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>DE CONFORMIDAD CON LO ESTABLECIDO EN EL ARTICULO 18, PARÁGRAFO SEGUNDO DE LA PROVIDENCIA ADMINISTRATIVA MEDIANTE LA CUAL SE DESIGNAN AGENTES DE RETENCIÓN DEL SENIAT/2013/0030 GACETA OFICIAL 40.170 DE FECHA 20-05-2013, SE ESTABLECE;" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>(...) LOS COMPROBANTES PODRÁN SER ENTREGADOS AL PROVEEDOR EN MEDIOS ELECTRÓNICOS, CUANDO ASÍ LO CONVENGAN CON EL AGENTE DE RETENCIÓN (...)" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>EN TAL SENTIDO, HACEMOS LLEGAR A TRAVÉS DE ESTE MEDIO ELECTRÓNICO LOS COMPROBANTES DE RETENCIÓN DE LAS RETENCIONES PRACTICADAS POR LA ALCALDIA DEL MUNICIPIO ESTELLER. NO OBSTANTE, SI DESEAN OBTENER EL FÍSICO DEL COMPROBANTE DE RETENCIÓN," +
                " </td>" +
                " </tr>" +
                " <tr>" +
                //+ "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO alcaldiadeesteller@gmail.com" + " </td>"
                "<td>PODRÁN RETIRARLO EN NUESTRA OFICINA, REALIZANDO PREVIAMENTE SU RESPECTIVA SOLICITUD A TRAVÉS DE LA DIRECCIÓN: DE CORREO ELECTRÓNICO" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                //+ "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO 0256 - 336-1055. DEPARTAMENTO DE ADMINISTRACION, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." + " </td>"
                "<td>O A TRAVÉS DEL NUMERO TELEFÓNICO DEL DEPARTAMENTO DE ADMINISTRACION, INDICANDO LOS SIGUIENTES DATOS DEL CONTRIBUYENTE : NOMBRE DE LA EMPRESA, NÚMERO DE R.I.F, PERIODO IMPOSITIVO, NÚMERO DE FACTURA." +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>" +
                " </td>" +
                " </tr>" +
                " <tr>" +
                "<td>&nbsp;</td>" +
                " </tr>" +
                " <tr>" +
                " <td>&nbsp;</td>" +
                " </tr>    <tr>" +
                "<td></td>" +
                "</tr>    <tr>" +
                '	<td align="right">Alcald&iacute;a Bolivariana del Municipio Esteller</td>' +
                " </tr>    <tr>" +
                '<td align="right">Municipio Socialista</td>' +
                " </tr>" +
                " <tr>  </tr>" +
                " <tr>  </tr>" +
                "<tr>" +
                " <td> Nota: No respondas o reenvíes mensajes a través de esta dirección de correo electrónico. </td>" +
                "</tr>" +
                " </table></body></html>";
              break;
          }
          if (html === "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Correo No Enviado",
              icono: "informacion",
            });
            return;
          }
          let pos =
            espiritu === 0 ||
            espiritu === 1 ||
            espiritu === 2 ||
            espiritu === 3 ||
            espiritu === 12 ||
            espiritu === 15
              ? espiritu
              : 25;
          let body = {
            correo: op.espiritu[pos].email,
            clave: op.espiritu[pos].clave,
            dep: dep,
            html: html,
            retenciones: datosrete,
            contribuyente: txtNombreprov.current.value.trim(),
            /*email: "informaticoc.r05@gmail.com",
                  email2: "sistemadecorreos2021@gmail.com",*/
            email: txtCorreoP.current.value.trim(),
            email2: txtCorreoS.current.value.trim(),
          };
          console.log({
            body,
          });
          endpoint = `${op.reportes}/administracionTesoreria/enviarcorreo`;
          axios
            .post(endpoint, body, {
              headers: {
                "x-access-token": `${token}`,
                "Content-Type": "application/json",
              },
            })
            .then(function (response) {
              if (response.status === 200) {
                //setMensaje({ mostrar: true, titulo: "Notificación", texto: "Correo Enviado", icono: "informacion", });
                let body = {
                  retenciones: selectedItems,
                  idprove: txtIdprov.current.value,
                  correoep: txtCorreoP.current.value,
                  correoes: txtCorreoS.current.value,
                };
                let endpoint = `${op.conexion}/api/administracion/actualizarretencioncorreo`;
                axios
                  .post(endpoint, body, {
                    headers: {
                      "x-access-token": `${token}`,
                      "Content-Type": "application/json",
                    },
                  })
                  .then(function (response) {
                    if (response.status == 200) {
                      setMensaje({
                        mostrar: true,
                        titulo: "Notificación",
                        texto: "Correo Enviado",
                        icono: "informacion",
                      });
                    }
                    setActivate(false);
                  })
                  .catch(function (error) {
                    setActivate(false);
                    setMensaje({
                      mostrar: true,
                      titulo: "Error",
                      texto: error.response.data.message,
                      icono: "error",
                    });
                  })
                  .finally(() => setActivate(false));
              }
            })
            .catch(function (error) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: error.response.data.message,
                icono: "informacion",
              });
            })
            .finally(() => setActivate(false));
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      txtFechaRetencion.current.value = moment
        .utc(records[cmbTipoRetencion.current.selectedIndex].fecharet)
        .format("YYYY-MM-DD");
    }
    if (e.target.name === "codigo") {
      blanquear();
    }
  };

  const handleOrdenPago = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        // setIdOrden(event.target.value);
        seleccionarOrdenPago(event.target.value, 0);
      }
    }
  };

  useEffect(() => {
    const newArr = records.map((item) => {
      return { value: item.idret, label: item.descripcion.trim() };
    });
    setNewRecord(newArr);
  }, [records]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setHabiBuscar(true);
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <h3 className="fs-4 fw-bold text-light m-0">
          {"Impresión de Retenciones" +
            (existePlani ? "" : "-- Ultima Generada:" + ultimo)}
        </h3>
        <button
          className="btn btn-sm bg-light"
          onClick={() => {
            txtCodigo.current.value = "";
            blanquear();
            cerrarModal();
          }}
        >
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtIdprov} />
          <fieldset className="col-12 border-azul rounded m-0 p-4 d-flex flex-wrap justify-content-between">
            <div className="col-4 m-0 mb-2 p-0">
              <SearchInput
                label="Código:"
                autoComplete="off"
                name="codigo"
                disabled={!habiBuscar}
                onChange={onChange}
                onKeyUp={handleOrdenPago}
                onBlur={handleInputNumChange}
                id="idorden"
                disabledButton={!habiBuscar}
                onClickButton={catalogoOrdenPago}
                ref={txtCodigo}
              />
            </div>
            <div className="col-6 m-0 mb-2 p-0">
              <Input
                label="Monto de la Orden:"
                disabled
                id="inputDireccion"
                ref={txtMontoOrden}
              />
            </div>
            <TableContainer>
              <Table>
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={records.length}
                  headCells={headCells}
                />
              </Table>
            </TableContainer>
            <Paper
              style={{
                width: "100%",
                marginBottom: "10px",
                height: "300px",
                overflowY: "scroll",
              }}
            >
              <TableContainer>
                <Table
                  style={{
                    minWidth: 750,
                  }}
                  aria-labelledby="tableTitle"
                  size="small"
                  aria-label="enhanced table"
                >
                  <tbody>
                    {stableSort(
                      filterFn.fn(records),
                      getComparator(order, orderBy),
                    )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idret);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <tr
                            hover
                            onClick={(event) => handleClick(event, row)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idret}
                            selected={isItemSelected}
                          >
                            <td padding="checkbox" style={{ width: "40px" }}>
                              <Checkbox
                                checked={isItemSelected}
                                //disabled={row.ret_planillaenv ? false : true}
                                color="primary"
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </td>

                            <td style={{ width: "200px" }} align="center">
                              {row.descripcion}
                            </td>

                            <td style={{ width: "80px" }} align="center">
                              {row.ret_planillaenv ? "SI" : "NO"}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </TableContainer>
            </Paper>

            <div className="col-12 col-lg-6 m-0 mb-2 p-0 pr-lg-2">
              <Select
                label="Tipo de retención:"
                onChange={onChange}
                name="tipo"
                options={newRecord}
                ref={cmbTipoRetencion}
              />
            </div>
            <div className="col-12 col-lg-6 m-0 mb-2 p-0">
              <Input
                label="Tipo Compromiso:"
                disabled
                id="inputDireccion"
                ref={txtTipoCompromiso}
              />
            </div>
            <div className="col-6 col-lg-4 m-0 mb-2 p-0 pr-lg-2">
              <Input
                label="Fecha Orden:"
                type="date"
                disabled
                id="inputDireccion"
                ref={txtFechaOrden}
              />
            </div>
            <div className="col-6 col-lg-4 m-0 mb-2 p-0 pr-lg-2">
              <Input
                label="Fecha Retención:"
                type="date"
                disabled={!habiFechaRet}
                id="inputDireccion"
                ref={txtFechaRetencion}
              />
            </div>
            <div className="col-6 col-lg-4 m-0 mb-2 p-0">
              <Input
                label="N° Planilla:"
                type="text"
                disabled={!habiNumPlani}
                id="inputDireccion"
                ref={txtNumeroPlanilla}
              />
            </div>
            <div className="col-6 col-lg-4 m-0 mb-2 p-0 pr-lg-2">
              <Input
                label="Cedula/Rif:"
                disabled
                id="inputDireccion"
                ref={txtCedurifprov}
              />
            </div>
            <div className="col-12 col-lg-8 m-0 mb-2 p-0">
              <Input
                label="Beneficiario/Proveedor:"
                disabled
                id="inputDireccion"
                ref={txtNombreprov}
              />
            </div>
            <div className="col-12 col-lg-6 m-0 mb-2 mb-lg-0 p-0 pr-lg-2">
              <Input
                label="Correo Principal:"
                disabled={!habiCorreo}
                id="inputEmail1"
                placeholder="Example@gmail.com"
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
                ref={txtCorreoP}
              />
            </div>
            <div className="col-12 col-lg-6 m-0 mb-2 mb-lg-0 p-0">
              <Input
                label="Correo Secundario:"
                disabled={!habiCorreo}
                id="inputEmail2"
                placeholder="Example@gmail.com"
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
                ref={txtCorreoS}
              />
            </div>
            <div
              className="col-12 d-flex align-items-center gap-2 m-0 my-2 p-0"
              style={{ visibility: true }}
            >
              <span>Planilla por Hoja:</span>
              <div>
                <Radio
                  label="Si"
                  defaultChecked
                  name="checkVAlor"
                  value="1"
                  id="checkVAlor"
                  ref={radioSi}
                />
              </div>
              <div>
                <Radio
                  label="No"
                  type="radio"
                  name="checkVAlor"
                  value="2"
                  id="checkVAlor"
                  ref={txtNo}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <InfoButton
          icon="fa-print"
          disabled={!habiBot}
          onClick={imprimirPlanila}
          ref={btnImprimir}
        >
          Imprimir
        </InfoButton>
        <PrimaryButton
          icon="fa-envelope"
          disabled={!habiBot}
          onClick={enviarCorreo}
          ref={btnEnviar}
        >
          Enviar Correo
        </PrimaryButton>
        <Button
          variant="secondary rounded-pill"
          disabled={false}
          onClick={cancelar}
        >
          Cancelar
          <i className="fw-bold fas ms-2 fas fa-window-close me-1"></i>
        </Button>
        <DangerButton
          //variant="danger"
          onClick={() => {
            txtCodigo.current.value = "";
            blanquear();
            cerrarModal();
          }}
          icon="fa-sign-out-alt"
          //className="me-2 col-md-2 btn-sm rounded-pill"
        >
          {/* <i className="fas fa-times me-1"></i> */} Salir
        </DangerButton>
      </Modal.Footer>
      <CatalogoOrdenesdePagosPlanillas
        show={mostrar4}
        onHideCancelar={handleCancelaOrdenPago}
        onHideAceptar={handleAceptarOrdenPago}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito." ? cerrarModal() : cerrarMensaje();
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() => {
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
          if (desde === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "El Egreso Nª" + idOrden + " fué Registrado Correctamente",
              icono: "exito",
            });
          }
        }}
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
